import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { FormError, SubmitButton } from "@/components/common";
import { CustomerVehicle } from "@/modules/invoices/InvoiceDialogs";
import { useFetch } from "@/lib/useFetch";
import { api, errMsg } from "@/lib/api";
import { t } from "@/i18n";

export function NewQuoteDialog({ onClose, onDone }) {
  const [f, setF] = useState({ customer_id: "", vehicle_id: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const customers = useFetch("/customers");
  const vehicles = useFetch("/vehicles", { customer_id: f.customer_id || "none" });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/quotes", { customer_id: f.customer_id, vehicle_id: f.vehicle_id || null });
      toast.success(t("quotes.created"));
      onDone(data);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="new-quote-dialog">
        <DialogHeader><DialogTitle>{t("quotes.new")}</DialogTitle><DialogDescription>{t("quotes.newStandaloneHint")}</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <FormError message={error} />
          <CustomerVehicle f={f} setF={setF} customers={customers.data} vehicles={vehicles.data} prefix="quote" />
          <SubmitButton busy={busy} disabled={!f.customer_id} className="w-full" data-testid="quote-create-submit">{t("quotes.new")}</SubmitButton>
        </form>
      </DialogContent>
    </Dialog>
  );
}
